import { c as _c } from "react/compiler-runtime";
import type { Cruz } from '@cruz-com/lookup';
import _ from 'lodash';
import NextLink from 'next/link';
import { Avatar } from '@/components';
export const UserInfo = t0 => {
  const $ = _c(30);
  const {
    d,
    hideLead
  } = t0;
  if (!d) {
    return null;
  }
  const {
    first_name,
    last_name,
    user_base_url,
    location,
    photo_url
  } = d;
  const userName = `${first_name} ${last_name}`;
  let t1;
  if ($[0] !== location) {
    t1 = location || {};
    $[0] = location;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    city,
    state_abbr
  } = t1;
  const t2 = `${user_base_url}/vehicles`;
  const t3 = `View ${userName}'s vehicles`;
  const t4 = photo_url || "";
  let t5;
  if ($[2] !== t4 || $[3] !== userName) {
    t5 = <Avatar photo_url={t4} className="size-10" name={userName} />;
    $[2] = t4;
    $[3] = userName;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== userName) {
    t6 = <h3 className="m-0! truncate p-0! text-base/6! font-semibold! md:text-sm!">{userName}</h3>;
    $[5] = userName;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== city || $[8] !== state_abbr) {
    t7 = _.isEmpty(city) ? <span className="sr-only">Unknown Location</span> : <><span className="sr-only">Location: </span>{city}, {state_abbr}</>;
    $[7] = city;
    $[8] = state_abbr;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== city) {
    t8 = _.isEmpty(city) && <span aria-hidden="true">[Unknown Location]</span>;
    $[10] = city;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <address className="m-0 truncate p-0 text-sm/6 font-light not-italic">{t7}{t8}</address>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <div>{t6}{t9}</div>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t5) {
    t11 = <div className="flex items-center gap-x-4 px-4 py-2.5 font-semibold">{t5}{t10}</div>;
    $[18] = t10;
    $[19] = t5;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t2 || $[23] !== t3) {
    t12 = <NextLink hrefLang="en" href={t2} className="block" aria-label={t3}>{t11}</NextLink>;
    $[21] = t11;
    $[22] = t2;
    $[23] = t3;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== hideLead) {
    t13 = !hideLead && <div className="h-[42px] border-t" aria-hidden="true" />;
    $[25] = hideLead;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <section className="w-full border-t hover:bg-zinc-100 dark:hover:bg-zinc-800/50" aria-label="Seller Profile">{t12}{t13}</section>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};